import type {
  Autonomia,
  Capacidad,
  Entorno,
  EstrategiaOrg,
  Familia,
  Intensidad,
  Lado,
  Modalidad,
  NivelClase,
  NivelEjercicio,
  Poblacion,
  TipoClase,
  Variacion,
  AlturaTrabajo,
  EstadoClase
} from '../types'

export const POBLACIONES: Poblacion[] = ['Infancias', 'Adolescentes', 'Adultos', 'Mixto']

export const NIVELES_CLASE: NivelClase[] = [
  'Introducción',
  'Básico',
  'Intermedio',
  'Avanzado',
  'Multinivel'
]

export const NIVELES_EJERCICIO: NivelEjercicio[] = [
  'Introducción',
  'Básico',
  'Intermedio',
  'Avanzado'
]

export const ORDEN_NIVEL: Record<NivelEjercicio, number> = {
  'Introducción': 0,
  'Básico': 1,
  'Intermedio': 2,
  'Avanzado': 3
}

export const AUTONOMIAS: Autonomia[] = [
  'Primer contacto',
  'En aprendizaje',
  'Con asistencia',
  'Autónomo',
  'Consolidado'
]

export const TIPOS_CLASE: TipoClase[] = [
  'Clase habitual',
  'Clase de prueba',
  'Intensivo',
  'Preparación de muestra',
  'Evaluación/repaso'
]

export const ALTURAS: AlturaTrabajo[] = ['Piso', 'Nudo', 'Baja altura', 'Altura', 'Mixta']

export const OBJETIVOS: string[] = [
  'Introducción',
  'Fuerza',
  'Flexibilidad',
  'Trepas',
  'Llaves',
  'Inversiones',
  'Figuras',
  'Transiciones',
  'Secuencias',
  'Creatividad',
  'Muestra',
  'Repaso',
  'Personalizado'
]

export const DURACIONES = [45, 60, 75, 90, 120]

export const ESTRATEGIAS: EstrategiaOrg[] = [
  'Individual',
  'Parejas',
  'Estaciones',
  'Rotaciones',
  'Otra'
]

export const ESTADOS: EstadoClase[] = ['Borrador', 'Planificada', 'Realizada']

export const LADOS: Lado[] = ['No aplica', 'Derecho', 'Izquierdo', 'Ambos']
export const MODALIDADES: Modalidad[] = ['Grupo completo', 'Parejas', 'Estaciones', 'Individual']
export const VARIACIONES: Variacion[] = ['Regresión', 'Base', 'Progresión', 'Personalizada']

export const CAPACIDADES: Capacidad[] = [
  'Agarre',
  'Tracción',
  'Empuje',
  'Core',
  'Control corporal',
  'Control escapular',
  'Movilidad',
  'Movilidad de hombros',
  'Flexibilidad',
  'Coordinación',
  'Resistencia',
  'Lateralidad',
  'Expresión',
  'Memoria'
]

export const FAMILIAS: Familia[] = [
  'Activación y movilidad',
  'Preparación física específica',
  'Trepas y descensos',
  'Llaves y envolturas',
  'Inversiones y control',
  'Figuras estáticas',
  'Transiciones y secuencias',
  'Expresión y creatividad',
  'Flexibilidad y vuelta a la calma'
]

export const ENTORNOS: Entorno[] = ['Piso', 'Nudo', 'Baja altura', 'Altura']
export const INTENSIDADES: Intensidad[] = ['Baja', 'Media', 'Alta']

export const CHECKS_LOGISTICA: { id: string; texto: string }[] = [
  { id: 'espacio', texto: 'Espacio de trabajo despejado.' },
  { id: 'colchonetas', texto: 'Colchonetas colocadas según la actividad.' },
  { id: 'telas', texto: 'Telas y herrajes revisados visualmente.' },
  { id: 'anclaje', texto: 'Punto de anclaje/rigging habilitado por personal competente.' },
  { id: 'asistencia', texto: 'Entradas, salidas y asistencia previstas para contenidos nuevos.' },
  { id: 'rotacion', texto: 'Plan de rotación definido cuando se comparte aparato.' },
  { id: 'botiquin', texto: 'Botiquín y procedimiento de emergencia accesibles.' }
]

export const NOMBRES_BLOQUES: string[] = [
  'Preparación previa y explicación',
  'Activación general',
  'Preparación física específica',
  'Técnica base',
  'Objetivo principal',
  'Integración o secuencia',
  'Acondicionamiento opcional',
  'Vuelta a la calma'
]

export const IDS_TREPA = ['T01', 'T02', 'T03', 'T04', 'T05', 'T06']
export const IDS_DESCENSO = ['T07', 'T08']
export const IDS_INVERSION_AEREA = ['I05', 'I06']

/** Recursos considerados intensos de agarre o tracción para la advertencia de fatiga. */
export const IDS_INTENSOS_AGARRE = [
  'F05',
  'T03',
  'T04',
  'T05',
  'T06',
  'T08',
  'I03',
  'I04',
  'I05',
  'I06',
  'L07',
  'L08',
  'S02',
  'S04'
]
